import { Checkbox, Flex, Text } from '@radix-ui/themes';
import { DeliveryEmailInput } from './DeliveryEmailInput';

interface Props {
    emails: string[];
    onEmailsChange: (val: string[]) => void;
    notifySender: boolean;
    onNotifyChange: (val: boolean) => void;
    labels: { recipients: string; notify: string };
    suggestedEmails?: string[];
}

export const DeliveryRecipientForm = ({
    emails,
    onEmailsChange,
    notifySender,
    onNotifyChange,
    labels,
    suggestedEmails,
}: Props) => (
    <Flex direction='column' gap='3'>
        <DeliveryEmailInput
            emails={emails}
            onEmailsChange={onEmailsChange}
            placeholder={labels.recipients}
            suggestedEmails={suggestedEmails}
        />

        <Text as='label' size='2' color='gray'>
            <Flex gap='2' align='center'>
                <Checkbox
                    checked={notifySender}
                    onCheckedChange={(c) => onNotifyChange(c === true)}
                    disabled={!emails.length}
                />
                {labels.notify}
            </Flex>
        </Text>
    </Flex>
);
